import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, HostBinding, Input } from '@angular/core';

import { ValueSliderDirective } from '@frontend/sports/common/ui/value-slider';

import { SnookerScoreboardBaseComponent } from './scoreboard-base/snooker-scoreboard-base.component';

@Component({
    selector: 'ms-snooker-scoreboard',
    templateUrl: './snooker-scoreboard.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [NgClass, ValueSliderDirective],
})
export class SnookerScoreboardComponent extends SnookerScoreboardBaseComponent {
    @HostBinding('class') className = 'snooker';
    @Input() hideScoreBoardColumnFooter = false;
}
